import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../../utils';
import { Plus } from 'lucide-react';

export default function DevelopmentHeader() {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Pengembangan SDM</h1>
        <p className="text-gray-500 mt-1">Kelola program pelatihan dan pengembangan</p>
      </div>
      <Link to={createPageUrl('EmployeeDevelopmentForm')}>
        <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md font-medium flex items-center">
          <Plus className="w-4 h-4 mr-2" /> Tambah Program
        </button>
      </Link>
    </div>
  );
}
